/**
 * Created by cgeisler on 31.03.2017.
 */

export class ClientFunnelPlayTimeStateVO {
    constructor(
        public readonly timeDelayMinutes: number,
        public readonly eventState: string
    ) {
    }

    public get timeDelayMilliseconds(): number {
        return this.timeDelayMinutes * 60 * 1000;
    }
}
